import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { InfoSetTable } from "../InfoSets/InfoSetTable";
import { MacAddress } from "../Core/MacAddress";
import { IfTable, IfEntry } from "../InfoSets/IfTable";
import { SnmpConstants } from "../Core/SnmpConstants";
import { Device } from "../Core/Device";
import { List } from "../Utils/List";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface ApIfEntryJson {
//    ap_mac_address: string;
//    if_index: string;
//    slot_id: string;
//    port_id: string;
//    name: string;
//    description: string;
//    mac_address: string;
//    if_type: string;
//    admin_status: string;
//    oper_status: string;
//    speed: string;
//    channel: string;
//    num_of_users: string;
//    snr: string;
//}
    
export class ApIfEntryKey {
    public ApMacAddress: MacAddress;
    public IfIndex: number;

    constructor(apMacAddress: MacAddress, ifIndex: number) {
        this.ApMacAddress = apMacAddress;
        this.IfIndex = ifIndex;
    }
        
    public Equals(obj: any): boolean {
        if (!obj)
            return false;

        if (obj === this)
            return true;

        if (!(obj instanceof ApIfEntryKey))
            return false;

        var other = <ApIfEntryKey>obj;

        return ((other.ApMacAddress.Equals(this.ApMacAddress) && (other.IfIndex === this.IfIndex)));
    }

    public GetHashCode(): number {
        return (this.ApMacAddress.GetHashCode() ^ ObjUtils.GetHashCode(this.IfIndex));
    }
}

export class ApIfEntry /*implements ISerializable*/ implements ObjectSerializer {
    // KEY
    public ApMacAddress: MacAddress;
    public IfIndex: number;

    // ATTRIBUTES
    public SlotId: number;
    public get HasSlotId(): boolean {
        return this.SlotId >= 0;
    }

    public PortId: number;
    public get HasPortId(): boolean {
        return this.PortId >= 0;
    }

    public Name: string;
    public HasName(): boolean {
        return !!this.Name;
    }

    public Description: string;
    public HasDescription(): boolean {
        return !!this.Description;
    }

    public MacAddress: MacAddress;
    public get HasMacAddress(): boolean {
        return this.MacAddress && !this.MacAddress.IsNull;
    }

    public IfType: number;
    public get HasIfType(): boolean {
        return this.IfType >= 0;
    }

    public AdminStatus: number;
    public get HasAdminStatus(): boolean {
        return this.AdminStatus >= 0;
    }

    public OperStatus: number;
    public get HasOperStatus(): boolean {
        return this.OperStatus >= 0;
    }

    public Speed: number;
    public get HasSpeed(): boolean {
        return this.Speed > 0;
    }

    public Channel: string;
    public get HasChannel(): boolean {
        return !!this.Channel;
    }

    public NumOfUsers: number;
    public get HasNumOfUsers(): boolean {
        return this.NumOfUsers >= 0;
    }

    public SignalNoiseRatio: number;
    public get HasSignalNoiseRatio(): boolean {
        return this.SignalNoiseRatio >= 0;
    }

    public RadioIndex: number;
    public get HasRadioIndex(): boolean {
        return this.RadioIndex >= 0;
    }

    constructor(apMacAddress?: MacAddress, ifIndex?: number) {
        this.ApMacAddress = apMacAddress;
        this.IfIndex = ifIndex;

        this.Init();
    }

    private Init(): void {
        this.Name = '';
        this.Description = '';
        this.SlotId = -1;
        this.PortId = -1;
        this.MacAddress = null;
        this.AdminStatus = -1;
        this.OperStatus = -1;
        this.Speed = 0;
        this.Channel = '';
        this.NumOfUsers = -1;
        this.SignalNoiseRatio = -1;

        this.RadioIndex = -1;
    }

    public CopyTo(ifEntry: IfEntry): void {
        if (ifEntry == null)
            return;

        if (this.HasName)
            ifEntry.Name = this.Name + '';
        if (this.HasDescription) {
            ifEntry.Description = this.Description + '';
            if (!ifEntry.HasName)
                ifEntry.Name = ifEntry.Description + '';
        }
        if (this.HasMacAddress)
            ifEntry.MacAddress = this.MacAddress.Clone();

        if (this.HasAdminStatus)
            ifEntry.AdminStatus = this.AdminStatus;
        if (this.HasOperStatus)
            ifEntry.OperStatus = this.OperStatus;
        ifEntry.IfType = SnmpConstants.ifType_ieee80211;
        if (this.HasSpeed)
            ifEntry.Speed = this.Speed;
    }

    //public Deserialize(json: ApIfEntryJson) : void {
    //    if (json.ap_mac_address !== undefined)
    //        this.ApMacAddress = MacAddress.CreateFromString(json.ap_mac_address);

    //    if (json.if_index !== undefined)
    //        this.IfIndex = parseInt(json.if_index);

    //    if (json.slot_id !== undefined)
    //        this.SlotId = parseInt(json.slot_id);

    //    if (json.port_id !== undefined)
    //        this.PortId = parseInt(json.port_id);
                
    //    if (json.name !== undefined)
    //        this.Name = json.name;

    //    if (json.description !== undefined)
    //        this.Description = json.description;

    //    if (json.mac_address !== undefined)
    //        this.MacAddress = MacAddress.CreateFromString(json.mac_address);

    //    if (json.if_type !== undefined)
    //        this.IfType = parseInt(json.if_type);

    //    if (json.admin_status !== undefined)
    //        this.AdminStatus = parseInt(json.admin_status);

    //    if (json.oper_status !== undefined)
    //        this.OperStatus = parseInt(json.oper_status);

    //    if (json.speed !== undefined)
    //        this.Speed = parseInt(json.speed);

    //    if (json.channel !== undefined)
    //        this.Channel = json.channel;

    //    if (json.num_of_users !== undefined)
    //        this.NumOfUsers = parseInt(json.num_of_users);

    //    if (json.snr !== undefined)
    //        this.SignalNoiseRatio = parseInt(json.snr);
    //}

	public Write(obj: any, context: any): void {
		obj.ap_if_entry = {};
		obj = obj.ap_if_entry;

		obj.ap_mac_address = ValueEncoder.EncodeMacAddress(this.ApMacAddress);
		obj.if_index = ValueEncoder.EncodeInteger(this.IfIndex);

		if (this.HasSlotId)
			obj.slot_id = ValueEncoder.EncodeInteger(this.SlotId);
		if (this.HasPortId)
			obj.port_id = ValueEncoder.EncodeInteger(this.PortId);
		if (this.HasName)
			obj.name = this.Name;
		if (this.HasDescription)
			obj.description = this.Description;
		if (this.HasMacAddress)
			obj.mac_address = ValueEncoder.EncodeMacAddress(this.MacAddress);
		if (this.HasIfType)
			obj.if_type = ValueEncoder.EncodeInteger(this.IfType);
		if (this.HasAdminStatus)
			obj.admin_status = ValueEncoder.EncodeInteger(this.AdminStatus);
		if (this.OperStatus)
			obj.oper_status = ValueEncoder.EncodeInteger(this.OperStatus);
		if (this.HasSpeed)
			obj.speed = ValueEncoder.EncodeInteger(this.Speed);
		if (this.HasChannel)
			obj.channel = this.Channel;
		if (this.HasNumOfUsers)
			obj.num_of_users = ValueEncoder.EncodeInteger(this.NumOfUsers);
		if (this.HasSignalNoiseRatio)
			obj.snr = ValueEncoder.EncodeInteger(this.SignalNoiseRatio);
		if (this.HasRadioIndex)
			obj.radio_index = ValueEncoder.EncodeInteger(this.RadioIndex);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ap_if_entry)
			throw new Error();
		obj = obj.ap_if_entry;

        if (obj.ap_mac_address !== undefined)
            this.ApMacAddress = ValueEncoder.DecodeMacAddress(obj.ap_mac_address);

		if (obj.if_index !== undefined)
			this.IfIndex = ValueEncoder.DecodeInteger(obj.if_index);

        if (obj.slot_id !== undefined)
			this.SlotId = ValueEncoder.DecodeInteger(obj.slot_id);

        if (obj.port_id !== undefined)
			this.PortId = ValueEncoder.DecodeInteger(obj.port_id);

        if (obj.name !== undefined)
            this.Name = obj.name;

        if (obj.description !== undefined)
            this.Description = obj.description;

        if (obj.mac_address !== undefined)
			this.MacAddress = ValueEncoder.DecodeMacAddress(obj.mac_address);

        if (obj.if_type !== undefined)
			this.IfType = ValueEncoder.DecodeInteger(obj.if_type);

        if (obj.admin_status !== undefined)
			this.AdminStatus = ValueEncoder.DecodeInteger(obj.admin_status);

        if (obj.oper_status !== undefined)
			this.OperStatus = ValueEncoder.DecodeInteger(obj.oper_status);

        if (obj.speed !== undefined)
			this.Speed = ValueEncoder.DecodeInteger(obj.speed);

        if (obj.channel !== undefined)
            this.Channel = obj.channel;

        if (obj.num_of_users !== undefined)
			this.NumOfUsers = ValueEncoder.DecodeInteger(obj.num_of_users);

        if (obj.snr !== undefined)
			this.SignalNoiseRatio = ValueEncoder.DecodeInteger(obj.snr);

		if (obj.radio_index !== undefined)
			this.RadioIndex = ValueEncoder.DecodeInteger(obj.radio_index);
	}
}

export class ApIfTable extends InfoSetTable<ApIfEntryKey, ApIfEntry> {
    constructor(device: Device) {
        super(device);
    }

    public Add(apMacAddress: MacAddress, ifIndex: number): ApIfEntry {
        var apIfEntryKey = new ApIfEntryKey(apMacAddress, ifIndex);

        var apIfEntry: ApIfEntry = this._table.Item(apIfEntryKey);

        if (!apIfEntry) {
            apIfEntry = new ApIfEntry(apMacAddress, ifIndex);
            this._table.Add(apIfEntryKey, apIfEntry);
        }

        return apIfEntry;
	}

	public AddEntry(apIfEntry: ApIfEntry): boolean {
		var apIfEntryKey = new ApIfEntryKey(apIfEntry.ApMacAddress, apIfEntry.IfIndex);

		var tmp: ApIfEntry = this._table.Item(apIfEntryKey);

		if (!tmp) {
			this._table.Add(apIfEntryKey, apIfEntry);
			return true;
		}

		return false;
	}

    public FindByRadioIndex(apMacAddress: MacAddress, radioIndex: number): ApIfEntry {
        var foundEntry: ApIfEntry = null;

        this._table.Some((pair) => {
            var apIfEntry = pair.Value;
            if (apIfEntry.ApMacAddress == null)
                return;
            if (!apIfEntry.ApMacAddress.Equals(apMacAddress))
                return;
            if (apIfEntry.RadioIndex != radioIndex)
                return;

            foundEntry = apIfEntry;
            return true;
        });

        return foundEntry;
    }

    public RemoveByAddressIndex(apMacAddress: MacAddress, ifIndex: number): boolean {
        var apIfEntryKey = new ApIfEntryKey(apMacAddress, ifIndex);

        return this._table.Remove(apIfEntryKey);
    }

    public GetApIfEntries(apMacAddress: MacAddress): List<ApIfEntry> {
        var ifEntries = new List<ApIfEntry>();

        if (apMacAddress != null) {
            this._table.ForEach((pair) => {
                var apIfEntry = pair.Value;
                if (apIfEntry.ApMacAddress == null)
                    return;
                if (!apIfEntry.ApMacAddress.Equals(apMacAddress))
                    return;

                ifEntries.Add(apIfEntry);
            });
        }

        return (ifEntries);
    }

    //public DeserializeEntry(json: any): void {
    //    var entry = new ApIfEntry(null, -1);
    //    entry.Deserialize(json);
    //    var apIfEntryKey = new ApIfEntryKey(entry.ApMacAddress, entry.IfIndex);
    //    this._table.Add(apIfEntryKey, entry);
    //}

    //public EntryName(): string {
    //    return "ap_if_entry";
    //};

    //public static FromJson(json: any, device: Device): ApIfTable {
    //    var result = new ApIfTable(device);
    //    result.Deserialize(json);
    //    return result;
    //}

	public Write(obj: any, context: any): void {
		obj.ap_if_info = {};
		obj = obj.ap_if_info;

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._table.Values(), context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ap_if_info)
			throw new Error();
		obj = obj.ap_if_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new ApIfEntry();
				entry.Read(value, context);
				this.AddEntry(entry);
			}, this);
		}
	}

}
